import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import { timeFrameMenuBookActions } from './timeFrameMenuBookSlice';

function* fetchTimeFrameMenuBookList(action: PayloadAction<{ timeframeId: number }>) {
  try {
    // const response: CommonResponse<MenuBook[]> = yield call(timeframeService.getAll, action.payload.timeframeId);
    // yield put(timeFrameMenuBookActions.fetchTimeFrameMenuBookListSuccess(response));
  } catch (e) {
    yield put(timeFrameMenuBookActions.fetchTimeFrameMenuBookListFailed());
    yield handleResponseError(e as AxiosError);
  }
}

export default function* timeFrameMenuBookSaga() {
  yield takeLatest(timeFrameMenuBookActions.fetchTimeFrameMenuBookList.type, fetchTimeFrameMenuBookList);
}
